import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Main = styled.div`
	display: flex;
	padding: 1% 0px 0 0;
	justify-content: center;
`;

export const Sub = styled.div`
	display: flex;
	width: 49%;
	justify-content: center;
`;

export const ClientText = styled.div`
	color: ${colors.grey600};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 0 15px;
	padding-right: 0px;
`;

export const ClientSymbol = styled.div`
	background: transparent;
	border: solid transparent;
	border-bottom-color: #000;
	border-width: 8px;
	transform: translate3d(0, -35%, 0);
`;

export const MedianText = styled.div`
	color: ${colors.grey600};
`;

export const MedianSymbol = styled.div`
	border-width: 0 1px 0 0;
	border-style: dashed;
	height: 15px;
	padding: 0 0 0 18px;
`;
